import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

import { useApi } from '../../contexts/ApiContext';
import FormButton from '../buttons/FormButton';
import { Text } from '../fields';
import LoadingIcon from '../icons/LoadingIcon';
import Notification from './Notification';

import styles from '../../styles/popups/prompt-notification.module.css';

interface PromptNotificationProps {
    agent: string;
    instructionsExtra?: string;
    isJson?: boolean;
    className?: string | null;
    onClosed?: () => void;
    onResponse?: (response: any) => void;
}

function PromptNotification({
    agent,
    instructionsExtra = null,
    isJson = false,
    className = null,
    onClosed = null,
    onResponse = null,
}: PromptNotificationProps) {
    const [opened, setOpened] = useState(true);
    const [hasOpened, setHasOpened] = useState(opened);
    const api = useApi();

    const onRequestClose = () => {
        setOpened(false);
    };

    const [command, setCommand] = useState(null);
    const previousResponseIdRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState('');

    useEffect(() => {
        if (command === null) {
            return;
        }
        setLoading(true);
        api.ai
            .prompt(agent, command, {
                ...(previousResponseIdRef.current !== null
                    ? {
                          previous_response_id: previousResponseIdRef.current,
                      }
                    : null),
                ...(instructionsExtra !== null
                    ? {
                          instructions_extra: instructionsExtra,
                      }
                    : null),
            })
            .then((response) => {
                setLoading(false);
                const {
                    success = true,
                    data,
                    response_id: responseId = null,
                    format = 'text',
                } = response;
                previousResponseIdRef.current = responseId;
                if (success === false) {
                    return;
                }
                try {
                    let newResponse = null;
                    if (format === 'json') {
                        newResponse = JSON.parse(data);
                    } else if (format === 'javascript') {
                        newResponse = eval(data);
                    } else {
                        newResponse = data;
                    }
                    if (onResponse !== null) {
                        onResponse(newResponse);
                    }
                } catch (e) {
                    console.error(e);
                }
            });
    }, [agent, command, onResponse, isJson]);

    const onInputChange = (newValue) => {
        setInput(newValue);
    };
    const onFormSubmit = (event) => {
        event.preventDefault();
        if (input.trim().length > 0) {
            setCommand(input);
        }
        setInput('');
    };

    return (
        <Notification
            id={'prompt-notification'}
            opened={opened}
            withTransition
            withoutCloseButton
            className={classNames([styles.container, className])}
            onClosed={hasOpened ? onClosed : null}
            requestClose={onRequestClose}
        >
            <div className={styles.card}>
                <form onSubmit={onFormSubmit} className={styles.form}>
                    <div className={styles.field}>
                        <Text value={input} className={styles.input} onChange={onInputChange} />
                        {loading ? <LoadingIcon className={styles.loading} /> : null}
                    </div>
                    <FormButton type="submit" disabled={loading}>
                        Envoyer
                    </FormButton>
                </form>
            </div>
        </Notification>
    );
}

export default PromptNotification;
